























































































































































































































































































































































































































import { Component, Vue } from 'nuxt-property-decorator';
import { newsStore } from '~/store';
import { INewsArticle } from '~/models';
import { FreeTrialButton } from '~/components';

@Component({
  components: {
    FreeTrialButton
  }
})
export default class IndexPage extends Vue {
  selectedItem: number = 0;
  testimonialCount: number = 3;

  get latestNews () : INewsArticle[] {
    return newsStore.latestNews;
  }

  async asyncData () {
    await newsStore.getNews();
  }

  move_prev () {
    if (this.selectedItem == 0) {
      this.selectedItem = this.testimonialCount - 1;
    } else {
      this.selectedItem--;
    }
  }

  move_next () {
    this.selectedItem++;
  }
}
